import React, { PropsWithChildren } from 'react';
import { SWRConfig } from 'swr';

export const GlobalSWRConfig: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <SWRConfig
      value={{
        errorRetryInterval: 1000,
        errorRetryCount: 2,
        revalidateOnFocus: false,
        onError: (err, key) => {
          console.log('SWRConfig onError', err, key);
        },
      }}>
      {children}
    </SWRConfig>
  );
};
